<script>
  export default {
    name: 'ProductPagination',
    props: {
      pagination: Object,
      paginationStyle: String,
    },
    data() {
      return {
        localPagination: [],
      };
    },
    methods: {
      trans(key) {
        return _.get(window.translations, key, key);
      },
      pageListToLinks(pages) {
        const output = [];
        let previousPage = 0;

        for (const page of pages) {
          if (page - previousPage > 2) {
            output.push('...');
          } else if (page - previousPage === 2) {
            output.push(page - 1);
          }
          output.push(page);
          previousPage = page;
        }

        return output;
      },
      createPagination(currentPage, maxPage, pageSpan = 2) {
        const middleMin = Math.max(currentPage - pageSpan, 1);
        const middleMax = Math.min(currentPage + pageSpan, maxPage);
        let pages = Array.from({ length: middleMax - middleMin + 1 }, (_, i) => middleMin + i);

        if (middleMin !== 1) {
          pages.unshift(1);
        }
        if (middleMax !== maxPage) {
          pages.push(maxPage);
        }

        return this.pageListToLinks(pages);
      },
      generatePaginator(total, currentPage, pageSize) {
        const paginator = [];
        const numberOfPages = Math.ceil(total / pageSize);
        const pagesToShow = this.createPagination(currentPage, numberOfPages, 1);
        for (const value of pagesToShow) {
          if (value !== '...') {
            paginator.push({
              link: `${this.buildPageUrl(value, pageSize)}`,
              page: value,
              label: `${value}`,
            });
          } else {
            paginator.push({
              link: '',
              page: value,
              label: value,
            });
          }
        }

        return paginator;
      },

      buildPageUrl(page, perPage) {
        const url = new URL(window.location.href);
        url.searchParams.set('page', page);
        url.searchParams.set('perPage', perPage);
        return url.toString();
      },

      changePage(event, page) {
        if (event) {
          event.preventDefault();
        }
        const urlPage = new URL(window.location.href);
        urlPage.searchParams.set('page', page);
        window.history.replaceState(null, '', urlPage.toString());
        this.$emit('change-page', page);
      },
      previousPage() {
        if (this.pagination.current_page > 1) {
          this.changePage(null, this.pagination.current_page - 1);
        }
      },
      nextPage() {
        const totalPages = Math.ceil(this.pagination.total / this.pagination.per_page);
        if (this.pagination.current_page < totalPages) {
          this.changePage(null, this.pagination.current_page + 1);
        }
      },
    },
    computed: {
      computedPaginator() {
        return this.generatePaginator(
          this.pagination.total,
          this.pagination.current_page,
          this.pagination.per_page
        );
      },
    },
  };
</script>
<template>
  <div class="container-pagination">
    <template v-if="paginationStyle === 'standard'">
      <nav v-if="pagination && pagination.total > 0"
           class="d-flex justify-content-center">
        <ul class="pagination">
          <li class="page-item">
            <span class="page-link"
                  href="#"
                  aria-label="Previous"
                  aria-hidden="true"
                  @click.prevent="previousPage">&laquo;</span>
          </li>
          <li
            v-for="paginator in computedPaginator"
            :key="paginator.page"
            class="page-item"
            :class="{ active: paginator.page === pagination.current_page }"
          >
          <span
            v-if="paginator.link"
            :href="paginator.link"
            @click.prevent="changePage($event, paginator.page)"
            class="page-link"
          >
            {{ paginator.label }}
          </span>
            <span v-else class="page-link">{{ paginator.label }}</span>
          </li>
          <li class="page-item">
            <span class="page-link"
                  href="#"
                  aria-label="Next"
                  aria-hidden="true"
                  @click.prevent="nextPage">&raquo;</span>
          </li>
        </ul>
      </nav>
    </template>
    <template v-else>
      <div>
        <button class="btn-load-more" v-if="pagination?.current_page"
                @click="changePage($event, ++pagination.current_page )"
                :disabled="pagination.current_page > Math.ceil(pagination.total / pagination.per_page)">
          {{ trans("all.Load more") }}
        </button>
      </div>
    </template>
  </div>
</template>

<style scoped>

</style>
